<app-spinner *ngIf="loading"></app-spinner>

<div [hidden]="loading" id="game" class="game" [class.game-mobile]="!deviceSrv.isDesktop()">

  <ng-container #dynamicHost></ng-container>

  <div class="px-3 py-5 text-center" *ngIf="answersVerify">
    <app-spinner></app-spinner>
  </div>

</div>
